import { apiTypes } from 'ui/api'

export const formatContractName = (rate: apiTypes.RateResponse): string => {
	return `${rate.carrier || rate.providerName}${
		rate.contractNickname ? ' ' + rate.contractNickname : ''
	}`
}
